import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { PageNavigation, Content } from 'core/layouts';
import { EmptyState, QueryDropdown, BasicQueryCheckbox, TableFilter } from 'core/components';
import BaasicButton from 'themes/components/buttons/BaasicButton';
import { Page } from 'core/layouts';

function TemplateReportTemplate({ templateReportViewStore }) {
    const {
        queryUtility,
        facilityStore,
        patientStore,
        includeAllCheckboxStore,
        onIncludeAllChange,
        downloadReport,
        includeHospitalCheckboxStore,
        onIncludeHospitalChange,
        disabled,
        corporateStore
    } = templateReportViewStore;
    
    return (
        <Page>
            <PageNavigation>
                <BaasicButton
                    type='button'
                    className="btn btn--base btn--primary"
                    onClick={downloadReport}
                    label={'Download'}
                    icon='u-icon u-icon--sml u-icon--download--white'
                />
            </PageNavigation>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true} showFilterButtons={false}>
                    <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3 form__group">
                        <QueryDropdown queryUtility={queryUtility} store={patientStore} propertyName="patientId" label="Patient" />
                    </div>
                    <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3 form__group">
                        <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility" />
                    </div>
                    <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3 form__group">
                        <QueryDropdown queryUtility={queryUtility} store={corporateStore} propertyName="corporateId" label="Corporate"/>
                    </div>
                    <div className="col col-sml-6 col-med-6 col-xxlrg-1 checkbox--alignment form__group">
                        <label className="form__group__label"> </label>
                        <BasicQueryCheckbox
                            id='includeAll'
                            queryUtility={queryUtility}
                            propertyName='includeAll'
                            label='Include All'
                            store={includeAllCheckboxStore}
                            onChange={onIncludeAllChange}
                        />
                    </div>
                    <div className="col col-sml-6 col-med-6 col-xxlrg-1 checkbox--alignment form__group">
                        <label className="form__group__label"> </label>
                        <BasicQueryCheckbox
                            id='includeHospital'
                            queryUtility={queryUtility}
                            propertyName='includeHospital'
                            label='Include Hospital'
                            store={includeHospitalCheckboxStore}
                            onChange={onIncludeHospitalChange}
                            disabled={disabled}
                        />
                    </div>
                </TableFilter>
                </div>
            </Content>
        </Page>
    )
}

function renderEmpty() {
    return <EmptyState title='PATIENT.LIST.EMPTY_STATE.TITLE' description='PATIENT.LIST.EMPTY_STATE.DESCRIPTION' />
}

TemplateReportTemplate.propTypes = {
    templateReportViewStore: PropTypes.object
};

export default defaultTemplate(TemplateReportTemplate);
